import A11yDialog from 'a11y-dialog'
import Modal from './Modal'

const Cart = {
  init: () => {
    Cart.initDrawer()
    Cart.selectGift()
    document.addEventListener('click', Cart.clickHandler)
  },
  clickHandler: async (event) => {
    if (event.target.hasAttribute('data-cart-add')) {
      event.preventDefault()
      // console.log('adding to cart:', event.target.getAttribute('data-product-id'))
      event.target.disabled = true
      // event.target.classList.remove('bg-c-purple-dark')
      // event.target.classList.remove('bg-c-pink')
      // event.target.classList.remove('hover:bg-c-purple')
      // event.target.classList.add('bg-gray-800')
      // event.target.textContent = 'Adding...'

      // change button text
      if (event.target.hasAttribute('data-loading-text')) {
        event.target.textContent = `${event.target.getAttribute('data-loading-text')}...`
      }

      const product = event.target.getAttribute('data-product-id')
      const request = await Cart.addToCart({
        id: product,
        nonce: event.target.getAttribute('data-nonce'),
        confirm: event.target.getAttribute('data-confirm') || false,
      })
      const response = JSON.parse(request)
      const message = event.target.parentNode.querySelector('[data-notice]')

      // revert button text
      event.target.textContent = event.target.getAttribute('aria-label')
      
      // console.log('cart response', response)
      if (response.in_cart && message) {
        // event.target.textContent = 'In Cart'
        message.textContent = response.message
      }
      if (response.success) {
        if (response.is_subscription) {
          window.location.href = window.settings.checkoutUrl
          return
        }
        if ((response.use_subscription || response.use_credit) && window.modal) {
          const modalContent = document.getElementById('classes-confirm-modal-content')
          const confirmButton = document.getElementById(`confirm-modal-desc-${product}`).parentNode.querySelector(`[data-product-id="${product}"]`)

          modalContent.innerHTML = 
            `<h1 class="text-c-purple-dark font-bold text-xl text-center">
              ${response.message}
            </h1>`

          if (confirmButton) {
            confirmButton.textContent = 'Enrolled'
            confirmButton.disabled = true
            confirmButton.classList.remove('bg-c-purple-dark')
            confirmButton.classList.remove('bg-c-pink')
            confirmButton.classList.remove('hover:bg-c-purple')
            confirmButton.classList.add('bg-gray-800')
            confirmButton.classList.add('cursor-default')
          }
          // window.setTimeout(() => {
          //   window.modal.hide()
          // }, 1500)

          if (response.redirect) {
            window.location.href = response.redirect
          }
        } 
      }
      if (response.show_cart) {
        const cartContents = await Cart.getMiniCart()
        document.querySelector('.widget_shopping_cart_content').innerHTML = cartContents
        window.cartDrawer.show()
        // event.target.textContent = 'In Cart'
      }
      if (response.show_confirm && window.modal) {
        window.confirming = product
        window.modal.show()
      }
      if (response.show_confirm_general && window.confirmModal) {
        if (response.replace_confirm) {
          Modal.updateGeneralConfirm({
            message: response.message,
            hide_button: true,
          })
          window.confirmModal.show()
        } else {
          window.confirming = {}
          window.confirming.title = response.message
          window.confirming.attr = response.attr
          window.confirmModal.show()
        }
      }
      event.target.disabled = false
    }
  },
  addToCart: (product) => new Promise((resolve) => {
    let request = `${window.settings.requestUrl}?action=add_to_cart&product_id=${product.id}&nonce=${product.nonce}`
    if (product.confirm) {
      request += `&confirm=${product.confirm}`
    }
    // console.log('request', request)
    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          resolve(xhr.response);
        } else {
          // reject(xhr.status)
        }
      }
    };
    xhr.open('GET', request, true);
    xhr.send();
  }),
  getSubscription: (product) => new Promise((resolve) => {
    const request = `${window.settings.requestUrl}?action=get_subscription&product=${product.id}`
    // console.log('request', request)
    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          resolve(xhr.response);
        } else {
          // reject(xhr.status)
        }
      }
    };
    xhr.open('GET', request, true);
    xhr.send();
  }),
  getMiniCart: () => new Promise((resolve) => {
    const request = `${window.settings.requestUrl}?action=get_mini_cart`
    // console.log('request', request)
    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          resolve(xhr.response);
        } else {
          // reject(xhr.status)
        }
      }
    };
    xhr.open('GET', request, true);
    xhr.send();
  }),
  initDrawer: () => {
    window.cartDrawer = new A11yDialog(document.getElementById('cart-drawer'))
    window.cartDrawer.on('show', () => {
      document.documentElement.style.overflowY = 'hidden'
      document.body.classList.add('modal-open')

    })
    window.cartDrawer.on('hide', () => {
      document.documentElement.style.overflowY = ''
      document.body.classList.remove('modal-open')
    })
  },
  selectGift: () => {
    const inputs = document.querySelectorAll('[data-gift-watch]')
    if (inputs.length > 0) {
      for (let index = 0; index < inputs.length; index += 1) {
        const input = inputs[index];
        input.addEventListener('change', Cart.selectGiftChange)
      }
    }
  },
  selectGiftChange: (event) => {
    const giftSelect = document.getElementById('gift_product_select')
    if (giftSelect) {
      giftSelect.value = event.target.getAttribute('data-gift-id')
    }
  },
}
export default Cart